import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const AccountTerminalAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                {/* <div className='im-flex-row-item'>
                    <InputField
                        label='Account Terminal'
                        width='150px'
                        type="text"
                        value={chargeBatchUpdate.accResumeTerminal}
                        onChange={(e) => chargeDetailVM.onInputTextChange(e, 'accResumeTerminal', chargeBatchUpdate, 'chargeBatchUpdate')}
                        />
                </div> */}
                <div className='im-flex-row-item' style={{ width: "330px" }}>
                    <NbisCommonField
                        errorMessage={chargeBatchUpdate.allFormState?.["reasonCode"] ?? ""}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={chargeBatchUpdate?.reasonCode ?? ""}
                        fieldValue={chargeBatchUpdate?.reasonCode}
                        fieldLabel={"Reason Code"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'reasonCode'}
                        maxLength={60}
                        //isMultipleDropDown={true}
                        options={chargeDetailState.dynamicOptions.reasonCodeDropdownOptions}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>

            </div>
        </>
    )
}